import api from "api";


const tickets = {
    get: () => {
        return api().get('/users/wallet')
    },

    checkIn: (payload) => {
        return api().post('/checkin', payload)
    },

    create: (payload) => {
        return api().post('/products', payload)
    },

    update: (id, payload) => {
        return api().post(`/products/${id}`, payload)
    },

    delete: (id) => {
        return api().delete(`/products/${id}`)
    },

    createBulk: (payload) => {
        return api().post('/products/bulk', payload)
    },

    updateBulk: (payload) => {
        return api().put('/products/bulk', payload)
    },

    deleteBulk: (payload) => {
        return api().delete('/products/delete/bulk', payload)
    },

    // Tira o produto SÓ desse evento (detach da pivot) — o produto em si
    // continua existindo, inclusive se estiver em outro evento/estabelecimento.
    detachFromEvent: (productId, eventSlug) => {
        return api().delete(`/products/${productId}/events/${eventSlug}`)
    },

    getTicketForEvent: (slug) => {
        return api().get(`/events/detail/${slug}/tickets`)
    },

    removeDraft: (slug) => {
        return api().post(`/events/${slug}/finish`)
    },

    transfer: (ticketId, payload) => {
        return api().post(`/users/tickets/${ticketId}/transfer`, payload)
    },

    download: (ticketId) => {
        return api().get(`/users/tickets/${ticketId}/download`, {
            responseType: 'blob'
        })
    },

    getAllItems: (slug, query) => {
        const {
            type,
            deleted // include, exclude, only
        } = query;

        const validType = type === 'both' ? null : type;

        return api().get(`/events/${slug}/items`, {
            params: {
                type: validType,
                deleted
            }
        })
    }
}

export default tickets;